import React from 'react'
import styles from './index.module.sass'
import { CONTENT } from 'constants/animationConstants';
import { SimulationType } from 'types/app';
import { REMOTE_SIMULATION } from 'constants/sumilationConstants';
import { ControlType } from './ControlType';

interface ButtonsProps {
    toggleContentOpened: Function,
    openSelect: Function,
    opened: Boolean,
    activeSimulationType: SimulationType,
    posibleSimulationTypes: string[],
    setSimulationType: Function,
    isDone: Boolean,
    blockToggler: Boolean,
    restartSimulation: Function,
    hideToggler?: Boolean
}

const Buttons: React.FunctionComponent<ButtonsProps> = ({ 
    isDone, 
    toggleContentOpened, 
    blockToggler, 
    posibleSimulationTypes, 
    activeSimulationType, 
    openSelect, 
    hideToggler,
    opened, 
    setSimulationType, 
    restartSimulation
}) => {
    const isRemote = activeSimulationType === REMOTE_SIMULATION
    const isToggling = posibleSimulationTypes.length > 1

    let selectClicked = false
    const toggleSelect = () => {
        if(!selectClicked) {
            selectClicked = true
            openSelect()
        }
    }

    const toggleContentOpenedButton = () => !selectClicked && toggleContentOpened()

    const setSimType = (...args: any) => !selectClicked && setSimulationType(...args)

    return (
        <>
            <div className={styles.wrapper} data-type={CONTENT}>
                <div className={styles.bgfolder}></div>
                <div className={styles.topBtn} onClick={() => !blockToggler && toggleSelect()}>
                    <div></div>
                    <div></div>
                </div>
                <ControlType
                    show={hideToggler !== undefined ? false : (isToggling && !isDone)}
                    blockToggler={blockToggler || selectClicked}
                    isRemote={isRemote}
                    setSimulationType={setSimType}
                />
                    
                <div 
                    className={`${opened ? styles.bottomBtn : styles.guideButton}`}
                    onClick={() => toggleContentOpenedButton()}
                    style={{
                        display: isDone ? 'none' : 'flex',
                        pointerEvents: isDone ? 'none' : 'auto'
                    }}
                    >
                    <div></div>
                    <div></div>
                </div>
                <div 
                    className={styles.restart}
                    onClick={() => restartSimulation()}
                    style={{
                        display: !isDone ? 'none' : 'block',
                        pointerEvents: !isDone ? 'none' : 'auto'
                    }}
                    >
                        <div></div>
                        <div></div>
                </div>    
            </div>
        </>
    )
}

export default Buttons